import React from 'react'
import PropTypes from 'prop-types'
import { Path, Svg } from '@react-pdf/renderer'

const Block = ({ color }) => {
  return (
    <Svg
      width="20"
      height="18"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M10.5 20C9.11667 20 7.81667 19.7375 6.6 19.2125C5.38333 18.6875 4.325 17.975 3.425 17.075C2.525 16.175 1.8125 15.1167 1.2875 13.9C0.7625 12.6833 0.5 11.3833 0.5 10C0.5 8.61667 0.7625 7.31667 1.2875 6.1C1.8125 4.88333 2.525 3.825 3.425 2.925C4.325 2.025 5.38333 1.3125 6.6 0.7875C7.81667 0.2625 9.11667 0 10.5 0C11.8833 0 13.1833 0.2625 14.4 0.7875C15.6167 1.3125 16.675 2.025 17.575 2.925C18.475 3.825 19.1875 4.88333 19.7125 6.1C20.2375 7.31667 20.5 8.61667 20.5 10C20.5 11.3833 20.2375 12.6833 19.7125 13.9C19.1875 15.1167 18.475 16.175 17.575 17.075C16.675 17.975 15.6167 18.6875 14.4 19.2125C13.1833 19.7375 11.8833 20 10.5 20ZM10.5 18C12.7333 18 14.625 17.225 16.175 15.675C17.725 14.125 18.5 12.2333 18.5 10C18.5 9.1 18.3542 8.23333 18.0625 7.4C17.7708 6.56667 17.35 5.8 16.8 5.1L5.6 16.3C6.3 16.85 7.06667 17.2708 7.9 17.5625C8.73333 17.8542 9.6 18 10.5 18ZM4.2 14.9L15.4 3.7C14.7 3.15 13.9333 2.72917 13.1 2.4375C12.2667 2.14583 11.4 2 10.5 2C8.26667 2 6.375 2.775 4.825 4.325C3.275 5.875 2.5 7.76667 2.5 10C2.5 10.9 2.64583 11.7667 2.9375 12.6C3.22917 13.4333 3.65 14.2 4.2 14.9Z"
        fill={color}
      />
    </Svg>
  )
}

Block.propTypes = {
  color: PropTypes.string,
}

Block.defaultProps = {
  color: '',
}

export default Block
